import { requestApi } from '@app/api';
import { withPayment } from '@app/api/paths';

interface Notification {
  contact: string;
  createdAt: string;
  id: string;
  type: 'EMAIL';
  userId: string;
}

export type FetchPaymentNotificationResponse = Notification | null;

export function fetchPaymentNotification(
  workspaceId: string
): Promise<FetchPaymentNotificationResponse> {
  return requestApi<FetchPaymentNotificationResponse>({
    url: withPayment(`/workspaces/${workspaceId}/payment-notifications`),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data);
}

export type ChangePaymentNotificationResponse = Notification;

export function changePaymentNotification({
  contact,
  type,
  workspaceId,
}: {
  contact: string;
  type: 'EMAIL';
  workspaceId: string;
}): Promise<ChangePaymentNotificationResponse> {
  return requestApi<ChangePaymentNotificationResponse>({
    url: withPayment(`/workspaces/${workspaceId}/payment-notifications`),
    method: 'PUT',
    credentials: true,
    data: { contact, type },
  }).then((response) => response.data);
}
